/**
 * API Configuration
 * Automatically detects environment and uses correct API URL
 */

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://erasmus-production.up.railway.app'
    : 'http://localhost:8200');

export { API_URL };

